import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.start()

// if (document.body.classList.contains('home')) {
    const servicesSwiper = new Swiper(".servicesSlider", {
        modules: [Navigation, Pagination, Autoplay],
        spaceBetween: 24,
        slidesPerView: 1,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        loop: true,
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
        pagination: {
            el: ".services-pagination",
            clickable: true,
            bulletActiveClass: "swiper-pagination-bullet-active",
        },
    });

    const temoignagesSwiper = new Swiper(".temoignagesSlider", {
        modules: [Navigation, Pagination],
        spaceBetween: 32,
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    document.querySelectorAll(".clientsSlider").forEach((sliderEl) => {
        const wrapper = sliderEl.closest(".clients-slider-inner");
        if (!wrapper) return;

        new Swiper(sliderEl, {
            modules: [Navigation, Pagination, Autoplay],
            spaceBetween: 24,
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 32,
                },
            },
            pagination: {
                el: wrapper.querySelector(".clients-slider-pagination"),
                clickable: true,
            },
            navigation: {
                nextEl: wrapper.querySelector(".clients-slider-next"),
                prevEl: wrapper.querySelector(".clients-slider-prev"),
            },
        });
    });

    document.querySelectorAll(".partnersSlider").forEach((sliderEl) => {
        const wrapper = sliderEl.closest(".partners-slider-inner");
        if (!wrapper) return;

        new Swiper(sliderEl, {
            modules: [Navigation, Autoplay],
            spaceBetween: 24,
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 32,
                },
            },
            navigation: {
                nextEl: wrapper.querySelector(".partners-slider-next"),
                prevEl: wrapper.querySelector(".partners-slider-prev"),
            },
        });
    });
// }

document.addEventListener('wpcf7mailsent', (event) => {
    const container = event.detail?.unitTag
        ? document.getElementById(event.detail.unitTag)
        : event.target;
    const response = container?.querySelector('.wpcf7-response-output');
    if (!response) return;

    // Attendre le collapse des champs (.sent) avant de scroller
    setTimeout(() => {
        const header = document.querySelector('header.header');
        const offset = (header?.offsetHeight ?? 0) + 24;
        const top = Math.max(0, window.scrollY + response.getBoundingClientRect().top - offset);
        window.scrollTo({ top, behavior: 'smooth' });
    }, 100);
});